import {ApolloCache} from '@apollo/client';

import {StoredFilter} from 'filters/features/types';
import {StoredFilterType} from 'modules/decisionsNext/api/types';

import {fulfillPolicyFilterFragment} from 'features/GlobalFilterProvider/constants';
import {clearFilter} from 'filters/utils';
import {
  RecentPolicyFiltersDocument,
  RecentPolicyFiltersQuery,
  RecentPolicyFiltersQueryVariables,
  SavedPolicyFiltersDocument,
  SavedPolicyFiltersQuery,
  SavedPolicyFiltersQueryVariables,
} from 'features/GlobalFilterProvider/api/policyFilters.generated';
import {PolicyFilterTag} from 'constants/policyFilterTags';

export const pushPolicyFilterToRecent = ({
  cache,
  filter,
  type,
  tag,
}: {
  cache: ApolloCache<any>;
  filter: Omit<StoredFilter, 'lastUsed'>;
  type: StoredFilterType;
  tag: PolicyFilterTag;
}) => {
  cache.updateQuery<RecentPolicyFiltersQuery, RecentPolicyFiltersQueryVariables>(
    {
      query: RecentPolicyFiltersDocument,
      variables: {tag},
    },
    data => {
      if (!data) {
        return null;
      }

      return {
        storedFiltersV2: {
          policyFiltersList: [
            {
              tag,
              type,
              id: filter.id,
              name: filter.name,
              lastUsed: new Date().toISOString(),
              filter: fulfillPolicyFilterFragment(clearFilter(filter.filter)),
            },
            ...data.storedFiltersV2.policyFiltersList.filter(f => f.id !== filter.id).slice(0, 9),
          ],
        },
      } satisfies RecentPolicyFiltersQuery;
    }
  );
};

export const pushPolicyFilterToSaved = ({
  cache,
  filter,
  tag,
}: {
  cache: ApolloCache<any>;
  filter: Omit<StoredFilter, 'lastUsed'>;
  tag: PolicyFilterTag;
}) => {
  cache.updateQuery<SavedPolicyFiltersQuery, SavedPolicyFiltersQueryVariables>(
    {
      query: SavedPolicyFiltersDocument,
      variables: {tag},
    },
    data => {
      if (!data) {
        return null;
      }

      return {
        storedFiltersV2: {
          policyFiltersList: [
            ...data.storedFiltersV2.policyFiltersList.filter(f => f.id !== filter.id),
            {
              tag,
              type: StoredFilterType.Saved,
              id: filter.id,
              name: filter.name,
              lastUsed: new Date().toISOString(),
              filter: fulfillPolicyFilterFragment(clearFilter(filter.filter)),
            },
          ],
        },
      } satisfies SavedPolicyFiltersQuery;
    }
  );
};
